function Product() {
  return (
    <main className="sec-content sec-content_3">
      <div className="container-def">
        <div className="sec-content__wrap">
          <div className="product-info">
            <div className="product-info__top">
              <div className="product-info__title title-def title-def_sec3">Жидкость гидрофобизирующая <br/> RUTESIL® N</div>
              <div className="img-dec">
                <img src={window.location.origin+"/img/6.webp"} alt="" className="img-dec__img" />
              </div>
            </div>
            <div className="product-info__content wrap-article-2">
              <h4>Описание</h4>
              <p>Жидкость гидрофобизирующая Rutesil® N представляет собой водный раствор метилсиликоната  натрия.<br/>Применяется для модификации буровых растворов при бурении нефтяных и газовых скважин. </p>
              <p>Использование ее позволяет:</p>
              <ul>
                <li>обеспечить повышенную смазывающую способность;</li>
                <li>уменьшить поступление воды в буровой раствор из породы;</li>
                <li>снизить и стабилизировать вязкость бурового раствора.</li>
              </ul>
              <p></p>
              <h4>Основные характеристики</h4>
              <p>Внешний вид:  жидкость от бесцветного до коричневого цвета. Допускается наличие мелкодисперсного осадка.</p>
              <p>Массовая доля кремния: не менее 5%</p>
              <p>Щелочность в пересчёте на NaОН:  (13 – 19)%</p>
              <p>Плотность при температуре (20 ± 0,5) °С:  (1,15 -1,30) г/см куб.</p>
              <p></p>
              <h4>Упаковка</h4>
              <p>Контейнеры IBC 1 м куб.,  пластиковые или стальные бочки объемом 200 дм куб., 250 дм куб.</p>
              <p></p>
              <h4>Гарантийный срок хранения</h4>
              <p>1 год со дня изготовления.</p>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
export default Product;